import { useEffect } from 'react'

import { useQuery } from '@tanstack/react-query'

import searchTour from 'entities/tour/models/search-tour/search-tour'
import userStore from 'entities/user/module/user-store'

import { MainPageTours } from 'shared/api/tours/main-page'
import { IS_DIGITAL_TOUR_SUPPORT_ENABLED } from 'shared/constants/tours'

import { mapTourDocumentsToPreviews } from './map-tour-documents'

export { mapTourDocumentsToPreviews } from './map-tour-documents'

export const useLastTourDocuments = () => {
  const isAuthorized = Boolean(userStore.account)
  const enabled = IS_DIGITAL_TOUR_SUPPORT_ENABLED && isAuthorized

  const query = useQuery({
    queryKey: ['tours', 'last-documents'],
    queryFn: async ({ signal }) => {
      const { data: response } =
        await MainPageTours.getLastTourDocuments(signal)

      return response.data
    },
    select: (data) => ({
      tours: mapTourDocumentsToPreviews(data),
      limit: data.limit,
    }),
    enabled,
    staleTime: 0,
    retry: false,
    networkMode: 'always',
  })

  useEffect(() => {
    if (!IS_DIGITAL_TOUR_SUPPORT_ENABLED) return
    searchTour.setIsTourLimited(
      enabled && !query.isError ? (query.data?.limit ?? false) : false,
    )
  }, [enabled, query.data?.limit, query.isError])

  return {
    ...query,
    data: enabled && !query.isError ? query.data?.tours : undefined,
  }
}
